import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService} from '../_services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private storageService: StorageService, private router: Router) {}

  canActivate(): boolean {
    if (!this.storageService.isLoggedIn()) {
      this.router.navigate(['/login']); // Rediriger vers la page de connexion
      return false;
    }
    return true;
  }

  isAdmin():boolean{
    if(this.storageService.isAdmin()){
      return true
    }
    return false; 
  }

}